namespace $ {

	export class $shm_hitalama_map_history_storage_writers extends $giper_baza_dict_to(
		$shm_hitalama_map_history_storage_writer,
	) {}

}
